var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolichatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43 43",
    style: {
      enableBackground: "new 0 0 43 43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.5085,
    y1: 13.0381,
    x2: 16.3012,
    y2: 34.0078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ACBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9928,
    style: {
      stopColor: "#0083BA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,27.8h-2.7c-2.6,0-5.1-1.2-6.8-3.2c-1.7-2.1-2.3-4.7-1.7-7.3c0,0,0-0.1,0-0.1l0.1-0.2 c0.1-0.3,0.1-0.6,0.2-0.8c-0.7,0-1.1,0-1.2,0c-0.4,0-1,0-1.6,0.2c-2.1,0.6-2.5,2.4-2.6,3c-0.3,1.4-0.6,2.9-1,4.3l-0.1,0.5 c-0.2,0.9-0.4,1.8-0.6,2.7c-0.2,0.8-0.4,1.6-0.6,2.4c-0.1,0.4-0.2,0.9-0.3,1.3c-0.1,0.6-0.3,1.3-0.4,1.9c-0.3,1.2,0.1,2.2,1,2.8 c0.4,0.3,0.9,0.4,1.3,0.4c0.6,0,1.1-0.2,1.7-0.6c0.5-0.4,1.1-0.8,1.7-1.3c0.9-0.7,1.8-1.4,2.7-2.1c0.3-0.2,0.4-0.3,0.8-0.3 c2.1,0,4.2,0,6.2,0l0.9,0c1.7,0,2.9-0.9,3.3-2.4c0.1-0.2,0.1-0.5,0.3-1.1l-0.4,0C26.2,27.8,26.1,27.8,26,27.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.1879,
    y1: 13.8465,
    x2: 23.9805,
    y2: 34.8161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ACBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9928,
    style: {
      stopColor: "#0083BA"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.2,7.8c-0.4-0.3-0.9-0.4-1.3-0.4c-0.6,0-1.1,0.2-1.7,0.6c-0.5,0.4-1.1,0.8-1.7,1.3c-0.9,0.7-1.8,1.4-2.7,2.1 c-0.3,0.2-0.4,0.3-0.8,0.3c-2.1,0-4.2,0-6.2,0l-0.9,0c-1.7,0-2.9,0.9-3.3,2.4c-0.1,0.2-0.1,0.5-0.3,1.1l0.4,0c0.1,0,0.1,0,0.2,0h2.7 c2.6,0,5.1,1.2,6.8,3.2v0c1.7,2.1,2.3,4.7,1.7,7.3c0,0,0,0.1,0,0.1l0,0.2c-0.1,0.3-0.1,0.6-0.2,0.8c0.7,0,1.1,0,1.2,0 c0.4,0,1,0,1.6-0.2c2.1-0.6,2.5-2.4,2.6-3c0.3-1.4,0.6-2.9,1-4.3l0.1-0.5c0.2-0.9,0.4-1.8,0.6-2.7c0.2-0.8,0.4-1.6,0.6-2.4 c0.1-0.4,0.2-0.9,0.3-1.3c0.1-0.6,0.3-1.3,0.4-1.9C36.5,9.4,36.1,8.3,35.2,7.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.3273,
    y1: 13.4401,
    x2: 20.12,
    y2: 34.4097
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ACBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9928,
    style: {
      stopColor: "#0083BA"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.6,16.1l-2.9,0c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.1-0.4,1.2l0,0.2c0,0,0,0.1,0,0.1 c-0.5,2.3,0.1,4.7,1.7,6.5c1.4,1.6,3.6,2.6,5.9,2.6h2.2c0.1,0,0.1,0,0.2,0l0.5,0c0.1,0,0.3-0.1,0.3-0.1c0.1-0.1,0.2-0.2,0.2-0.3 l0.3-1.1c0,0,0-0.1,0-0.1c0.5-2.3-0.1-4.7-1.7-6.5C24,17,21.9,16.1,19.6,16.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolichatIcon);
export default __webpack_public_path__ + "static/media/polichat-icon.710ace615d41dba6e370cb9748e5ab56.svg";
export { ForwardRef as ReactComponent };